import {
	Component, OnInit, AfterViewInit, HostListener, Renderer2, ElementRef, NgZone,
	PLATFORM_ID, Inject, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserProfileService } from '../../services/Userprofile.service';
import { MainService } from '../../main.service';
import { AuthdataMessageService } from '../../authdata-message.service';
import * as globalConstant from '../../global_constant';
import { TopMenuComponent } from '../top-menu/top-menu.component';
import { DOCUMENT } from '@angular/common';
import { MessageService } from '../../message.service';

declare const fbq;
declare var pintrk: any;

@Component({
	selector: 'vebo-header',
	standalone: true,
	imports: [
		TopMenuComponent,
		CommonModule,
		RouterModule
	],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
	isBrowser: boolean;
	authCheck: boolean = false;
	authUser: any;
	isLogin: boolean = false;
	isInfluencer: boolean = false;
	tokenkey: any = '';
	baseUrl: any = '';
	currentURL: any = '';
	currentURL1: any = '';
	isBoat: boolean = false;
	cachedHeaderHeight: number = 0;
	isHeaderSticky: boolean = false;
	showAddExpBtns: boolean = false;
	couple_name: string = '';
	cover_image_url: string = '';
	showCountDownText: boolean = false;
	profile_img_url: string = '';
	showUploadProfileText: boolean = false;
	is_mobile_view: boolean = false;
	device_name: string = '';
	showCountDownTimer: boolean = false;

	WEDDING_COUPLE_ROLE_ID = globalConstant?.WEDDING_COUPLE_ROLE_ID;
	EXPERIENCE_PROVIDER_ROLE_ID = globalConstant?.EXPERIENCE_PROVIDER_ROLE_ID;
	CHARITY_USER_ROLE_ID = globalConstant?.CHARITIES_ROLE_ID;
	INDIVIDUAL_USER_ROLE_ID = globalConstant?.INDIVIDUAL_MEMBER_ROLE_ID;
	BBB_USER_ROLE_ID = globalConstant?.BBB_USER_ROLE_ID;
	BBB_BABY_USER_ROLE_ID = globalConstant?.BBB_BABY_USER_ROLE_ID;
	CUSTOMER_SUPPORT_ROLE_ID = globalConstant?.CUSTOMER_SUPPORT_ROLE_ID;
	ALTERNATE_EXPERIENCE_PROVIDER_ROLE_ID = globalConstant?.ALTERNATE_EXPERIENCE_PROVIDER_ROLE_ID;
	REGISTERFINDER_ROLE_ID = globalConstant?.REGISTERFINDER_ROLE_ID;
	KNOT_USER_ROLE_ID = globalConstant?.KNOT_USER_ROLE_ID;
	JOY_USER_ROLE_ID = globalConstant?.JOY_USER_ROLE_ID;
	ZOLA_USER_ROLE_ID = globalConstant?.ZOLA_USER_ROLE_ID;
	THNKS_USER_ROLE_ID = globalConstant?.THNKS_USER_ROLE_ID;
	SENDOSO_USER_ROLE_ID = globalConstant?.SENDOSO_USER_ROLE_ID;
	POSTAL_USER_ROLE_ID = globalConstant?.POSTAL_USER_ROLE_ID;
	GRAVITY_HAUS_USER_ROLE_ID = globalConstant?.GRAVITY_HAUS_USER_ROLE_ID;
	ALLY_BANK_USER_ROLE_ID = globalConstant?.ALLY_BANK_USER_ROLE_ID;


	private authDataMessageSubscription: Subscription;
	private authDataMessageProfilePicSubscription: Subscription;
	private urlSubscription: Subscription;

	boundScroll: any;
	boundResize: any;

	constructor(
		private router: Router,
		private userProfileService: UserProfileService,
		private authdataMessageService: AuthdataMessageService,
		public messageService: MessageService,
		private mainService: MainService,
		private renderer: Renderer2,
		private ngZone: NgZone,
		private cdr: ChangeDetectorRef,
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(platformId);
		if (this.isBrowser) {
			window.scrollTo(0, 0);
			this.isBoat = this.isSitePerformanceBoat();
			this.is_mobile_view = window.innerWidth < 768;
		}
		this.getMobileDeviceName();
		if (this.isBrowser) {
			if (localStorage.getItem('authUser')) {
				if (localStorage.getItem('login_token')) {
					this.tokenkey = localStorage.getItem('login_token');
					this.getUserAuthDataApi();
				}
			}
			this.baseUrl = window.location.origin;
		}

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (this.router?.url?.split("/")[1]) {
					if (this.isBrowser) {
						if (this.router?.url?.split("/")[1] != 'reset-password' && localStorage.getItem('login_type')) {
							localStorage.removeItem('login_type');
						}
						if (this.router?.url?.split("/")[2]) {
							if (this.router?.url?.split("/")[3]) {
								this.currentURL1 = this.router?.url?.split("/")[3];
							} else {
								this.currentURL1 = this.router?.url?.split("/")[2];
							}
						} else {
							this.currentURL1 = this.router?.url?.split("/")[1];
						}
					}
				} else {
					this.currentURL1 = "";
				}
				this.cdr.markForCheck();
			}
		});
	}

	ngOnInit() {
		this.authDataMessageSubscription = this.authdataMessageService.getAuthUserDataMessage().subscribe(message => {
			if (message && message.login_token && message.login_token.length > 0) {
				this.tokenkey = message.login_token;
			}
			this.getUserAuthDataApi();
		});

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (this.isBrowser) {
					this.onWindowScroll();
					if (!this.isBoat) {
						fbq('track', 'PageView');
						pintrk('page');
					}
					if (localStorage.getItem('authUser')) {
						if (localStorage.getItem('login_token')) {
							this.tokenkey = localStorage.getItem('login_token');
							this.authUser = localStorage.getItem('authUser');
							this.getUserAuthDataApi(true);
						}
					} else {
						this.isLogin = false;
						this.authCheck = false;
					}
				}
				this.currentURL = this.router?.url?.split("/")[1];
				this.cdr.markForCheck();
			}
		});

		this.authDataMessageProfilePicSubscription = this.authdataMessageService.getProfilePicMessage().subscribe(message => {
			if (message !== 'false') {
				this.profile_img_url = message;
				this.showUploadProfileText = false;
				this.cdr.markForCheck();
			}
		});

		this.urlSubscription = this.messageService.getData().subscribe((data) => {
			if (data) {
				this.currentURL = data;
				this.cdr.markForCheck();
			}
		});
	}

	ngAfterViewInit() {
		if (this.isBrowser) {
			const headerEl = document.getElementById("header");
			if (headerEl) {
				this.cachedHeaderHeight = headerEl.clientHeight;
			}

			this.ngZone.runOutsideAngular(() => {
				this.boundScroll = this.onWindowScroll.bind(this);
				window.addEventListener('scroll', this.boundScroll, { passive: true });

				this.boundResize = () => {
					this.navbarHeight();
					const headerElement = document.getElementById("header");
					if (headerElement) {
						this.cachedHeaderHeight = headerElement.clientHeight;
					}
					const isMobile = window.innerWidth < 768;
					if (this.is_mobile_view !== isMobile) {
						this.ngZone.run(() => {
							this.is_mobile_view = isMobile;
							this.cdr.markForCheck();
						});
					}
				};
				window.addEventListener('resize', this.boundResize);
			});
		}
	}

	ngOnDestroy() {
		if (this.urlSubscription) {
			this.urlSubscription.unsubscribe();
		}
		if (this.authDataMessageProfilePicSubscription) {
			this.authDataMessageProfilePicSubscription.unsubscribe();
		}
		if (this.authDataMessageSubscription) {
			this.authDataMessageSubscription.unsubscribe();
		}
		if (this.isBrowser) {
			if (this.boundScroll) {
				window.removeEventListener('scroll', this.boundScroll);
			}
			if (this.boundResize) {
				window.removeEventListener('resize', this.boundResize);
			}
		}
	}

	scrollTop() {
		if (this.isBrowser) {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		}
	}

	onWindowScroll() {
		if (!this.isBrowser) {
			return;
		}

		const navbar = document.getElementById('header');
		if (!navbar) {
			return;
		}

		// Match jQuery reference: cache height once while header is in normal flow
		if (!navbar.classList.contains('is-sticky')) {
			this.cachedHeaderHeight = navbar.offsetHeight || navbar.clientHeight;
		}

		const headH = this.cachedHeaderHeight || navbar.offsetHeight || 120;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		const padTarget = document.getElementById('vebo_body') || document.body;

		// Mirror jQuery thresholds (sticky/awake at 250, awake off at 50)
		if (scrollTop > 250) {
			if (!navbar.classList.contains('is-sticky')) {
				navbar.classList.add('is-sticky');
				padTarget.style.paddingTop = headH + 'px';
			}
		}

		if (scrollTop < 250) {
			if (navbar.classList.contains('is-sticky')) {
				navbar.classList.remove('is-sticky');
				padTarget.style.paddingTop = '0';
			}
		}

		if (scrollTop > 250) {
			if (!navbar.classList.contains('awake')) {
				// Let .is-sticky (off-screen, no transition) paint first, then .awake animates in
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						if ((window.pageYOffset || document.documentElement.scrollTop || 0) > 250) {
							navbar.classList.add('awake');
						}
					});
				});
			}
		}

		if (scrollTop < 50) {
			if (navbar.classList.contains('awake')) {
				navbar.classList.remove('awake');
			}
		}

		this.isHeaderSticky = navbar.classList.contains('is-sticky');
	}

	navbarHeight() {
		if (this.isBrowser) {
			const headerElement = document.getElementById("header");
			if (headerElement) {
				this.cachedHeaderHeight = headerElement.clientHeight;
			}
		}
	}

	getMobileDeviceName() {
		if (this.isBrowser) {
			const userAgent = navigator.userAgent;
			if (/android/i.test(userAgent)) {
				this.device_name = "android";
			} else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
				this.device_name = "ios";
			} else {
				this.device_name = "desktop";
			}
		}
	}

	isSitePerformanceBoat() {
		if (this.isBrowser) {
			const currentDomainName = window.location.hostname;
			if (currentDomainName.indexOf('localhost') > -1 || currentDomainName.indexOf('boat') > -1 || currentDomainName.indexOf('experiencebook') > -1) {
				return true;
			}
		}
		return false;
	}

	getUserAuthDataApi(navigation = false) {
		if (this.tokenkey != '') {
			this.userProfileService.get_auth_user_data({}, this.tokenkey).subscribe(res => {
				if (res.response == "success") {
					if (res.data.gift_voucher_received == 1) {
						this.showCountDownText = false;
					}
					if (this.isBrowser) {
						localStorage.setItem('base_img_url', res.base_url);
						localStorage.setItem('authUser', JSON.stringify(res.data));
					}
					this.initializeAuthUserData();
				}
			});
		}
	}

	initializeAuthUserData(fromNavigation = false) {
		if (this.isBrowser) {
			if (localStorage.getItem('authUser')) {
				this.authUser = JSON.parse(localStorage.getItem('authUser'));
				this.isInfluencer = this.authUser?.is_influencer == 1;
				this.authCheck = true;
				this.isLogin = true;
				this.showCountDownText = false;

				this.couple_name = this.authUser.first_name + ' & ' + this.authUser.partner_first_name;
				this.tokenkey = localStorage.getItem('login_token');

				if (this.authUser.cover_image !== '' && this.authUser.cover_image !== null && this.authUser.cover_image !== undefined) {
					this.cover_image_url = localStorage.getItem('base_img_url') + this.authUser.cover_image;
				} else {
					this.cover_image_url = 'assets/images/cover_image.jpg';
				}

				if ([1, 4, 5].includes(this.authUser.role_id)) {
					this.showAddExpBtns = true;
				}

				if (this.authUser.role_id == 1) {
					if (this.authUser.gift_voucher_received == 1) {
						this.showCountDownTimer = false;
						this.showCountDownText = false;
					} else {
						if (this.authUser.couple_expire_date && this.authUser.couple_expire_date != '') {
							this.showCountDownTimer = true;
						} else {
							this.showCountDownTimer = false;
						}
					}
				} else {
					this.showCountDownTimer = false;
					this.showCountDownText = false;
				}
				this.cdr.markForCheck();
			}
		}
	}
}
